/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Document_ClassifiedInputs */

const en_case_history_headline_document_classified = /** @type {(inputs: Case_History_Headline_Document_ClassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File classified`)
};

const pt_br2_case_history_headline_document_classified = /** @type {(inputs: Case_History_Headline_Document_ClassifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo classificado`)
};

/**
* | output |
* | --- |
* | "File classified" |
*
* @param {Case_History_Headline_Document_ClassifiedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_document_classified = /** @type {((inputs?: Case_History_Headline_Document_ClassifiedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Document_ClassifiedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_document_classified(inputs)
	return pt_br2_case_history_headline_document_classified(inputs)
});